import { Route, Switch, Redirect, useLocation } from 'wouter';
import { useAuth } from './context/AuthContext';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Activity } from './pages/Activity';
import { ClientDetail } from './pages/ClientDetail';
import { NewClient } from './pages/NewClient';
import { Reports } from './pages/Reports';
import { AuditLog } from './pages/AuditLog';
import { UsersPage } from './pages/Users';
import { MatchCandidates } from './pages/MatchCandidates';
import { UnlinkedFileNotes } from './pages/UnlinkedFileNotes';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { RequestAccess } from './pages/RequestAccess';
import { MfaEnroll } from './pages/MfaEnroll';
import { Shell } from './components/Shell';

const PUBLIC_PATHS = ['/forgot-password', '/reset-password', '/request-access'];

export function App() {
  const { user, loading } = useAuth();
  const [path] = useLocation();
  if (loading) return <div className="p-12 text-ink-mute">Loading…</div>;

  // Public onboarding pages — render regardless of auth state
  if (PUBLIC_PATHS.includes(path)) {
    return (
      <Switch>
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/reset-password" component={ResetPassword} />
        <Route path="/request-access" component={RequestAccess} />
      </Switch>
    );
  }

  if (!user) return <Login />;
  return (
    <Shell>
      <Switch>
        <Route path="/" component={Dashboard} />
        <Route path="/activity" component={Activity} />
        <Route path="/clients/new" component={NewClient} />
        <Route path="/clients/:id" component={ClientDetail} />
        <Route path="/reports" component={Reports} />
        <Route path="/audit" component={AuditLog} />
        <Route path="/users" component={UsersPage} />
        <Route path="/admin/match-candidates" component={MatchCandidates} />
        <Route path="/admin/unlinked-file-notes" component={UnlinkedFileNotes} />
        <Route path="/account/mfa" component={MfaEnroll} />
        <Route><Redirect to="/" /></Route>
      </Switch>
    </Shell>
  );
}
